(function () {
  function initDock(panel) {
    var baseSize = parseFloat(panel.dataset.baseSize) || 50;
    var magnification = parseFloat(panel.dataset.magnification) || 70;
    var distance = parseFloat(panel.dataset.distance) || 150;
    var items = Array.prototype.slice.call(panel.querySelectorAll('[data-dock-item]'));

    // Only enable the magnify effect for pointer devices (mouse/trackpad)
    var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!supportsHover || items.length === 0) return;

    function applyMagnification(mouseX) {
      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var dist = Math.abs(mouseX - itemCenter);

        var size;
        if (dist >= distance) {
          size = baseSize;
        } else {
          var factor = 1 - dist / distance;
          size = baseSize + (magnification - baseSize) * factor;
        }

        item.style.width = size + 'px';
        item.style.height = size + 'px';
      });
    }

    function reset() {
      items.forEach(function (item) {
        item.style.width = baseSize + 'px';
        item.style.height = baseSize + 'px';
      });
    }

    panel.addEventListener('mousemove', function (e) {
      applyMagnification(e.clientX);
    });

    panel.addEventListener('mouseleave', reset);
  }

  function initAllDocks() {
    document.querySelectorAll('.dock-panel').forEach(initDock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDocks);
  } else {
    initAllDocks();
  }

  // Re-init when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var panel = event.target.querySelector('.dock-panel');
    if (panel) initDock(panel);
  });
})();